import moment from 'moment';

const phase1Fields = {
  name: {
    value: '',
    error: null,
    name: 'name',
    placeholder: 'Name',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  pin_number: {
    value: '',
    error: null,
    name: 'pin_number',
    placeholder: 'PIN',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'pin',
    hasBlurred: false,
    inputType: 'text',
  },
  //is_active: {
  //  value: false,
  //  error: null,
  //  name: 'is_active',
  //  placeholder: 'Active or Inactive',
  //  breed: 'toggle',
  //  touched: false,
  //  isRequired: false,
  //  validationType: null,
  //  hasBlurred: false,
  //  inputType: 'text',
  //}
}

export default phase1Fields;



/** WEBPACK FOOTER **
 ** ./src/forms/cashiers/create.js
 **/